import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { RouterModule } from "@angular/router";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "app/helper-components/Shared.module";
import { NgxCaptchaModule } from "ngx-captcha";
import { VerifyReceiptComponent } from "./verify-receipt.component";
const routes = [
  {
    path: "verify/receipt/:id",
    component: VerifyReceiptComponent,
  },
];

@NgModule({
  declarations: [VerifyReceiptComponent],
  imports: [
    RouterModule.forChild(routes),

    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    NgxCaptchaModule,
    ReactiveFormsModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FuseSharedModule,
    TranslateModule,
    SharedModule,
  ],
})
export class VerifyReceiptModule {}
